/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */

import { Tabs as TabsBase } from "@base-ui-components/react/tabs";
import cx from "classnames";
import * as React from "react";

import "./Tabs.scss";

export interface ITabItem {
  id: string;
  label: string;
  content: React.ReactNode;
}

interface ITabsProps {
  tabs: ITabItem[];
  tabsBarExtraActions?: React.ReactNode;
  activeTabId?: string;
  className?: string;
  tabClassName?: string;
  tabListClassName?: string;
  onChange?: (
    value: TabsBase.Tab.Value,
    eventDetails: TabsBase.Root.ChangeEventDetails,
  ) => void;
}

export const Tabs: React.FC<ITabsProps> = ({
  className,
  tabClassName,
  tabListClassName,
  tabs,
  tabsBarExtraActions,
  activeTabId,
  onChange,
}) => {
  const [currentTabId, setCurrentTabId] = React.useState(
    activeTabId || tabs[0]?.id || "",
  );

  const onValueChange = (
    value: TabsBase.Tab.Value,
    eventDetails: TabsBase.Root.ChangeEventDetails,
  ) => {
    setCurrentTabId(value);
    if (onChange) {
      onChange(value, eventDetails);
    }
  };

  const renderExtraActions = () => {
    // if (!tabsBarExtraActions) {
    //   return null;
    // }

    return (
      <div className="tabs__tabs-bar-extra-actions">{tabsBarExtraActions}</div>
    );
  };

  return (
    <TabsBase.Root
      className={cx("tabs", className)}
      value={currentTabId}
      onValueChange={onValueChange}
    >
      <TabsBase.List className={cx("tabs__tabs-bar", tabListClassName)}>
        {tabs.map((tab) => (
          <TabsBase.Tab
            key={tab.id}
            value={tab.id}
            className={cx("tabs__tab", tabClassName)}
          >
            {tab.label}
          </TabsBase.Tab>
        ))}
        {renderExtraActions()}
      </TabsBase.List>
      <hr
        style={{
          border: "none",
          borderBottom: "1px solid #ccc",
          margin: "8px 0",
        }}
      />
      {tabs.map((tab) => (
        <TabsBase.Panel key={tab.id} value={tab.id}>
          {tab.content}
        </TabsBase.Panel>
      ))}
    </TabsBase.Root>
  );
};
